$(document).ready(function() {

  $(".catalog-list>ul>li").on("click", function(e) {
    if($(e.target).hasClass('li-item-not-dropdown')){
      return '';
    }

    if($(e.target).hasClass('main-li-item-not-dropdown')){
      return '';
    }
    
    if($(e.target).hasClass('cats2')){ // sub categories
      if (!$(e.target).hasClass('active-item')) {
        $(e.target).addClass('active-item');
      } else {
        $(e.target).removeClass('active-item');
      }
    } else{
      if (!$(this).hasClass('active-item')) {
        $(this).addClass('active-item');
      } else {
        
        $(this).removeClass('active-item');
        
      }
    }
    
  });

});